export const includesValueNormalized = (inputValue, expected) => {
  if (inputValue === null || inputValue === undefined) return false;

  if (Array.isArray(inputValue)) {
    return inputValue.map(String).includes(String(expected));
  }

  const asString = String(inputValue);
  const parts = asString.split(",").map(p => p.trim()).filter(Boolean);
  return parts.includes(String(expected));
};

export const handleConditionBaseFields = (value, formData, fieldId, ...triggerValues) => {
  const updatedFormData = { ...formData };
  const isVisible = triggerValues.some((v) => includesValueNormalized(value, v));

  updatedFormData.formFields = updatedFormData.formFields.map((field) => {
    if (field.id === fieldId) {
      return {
        ...field,
        validation: isVisible ? [{ type: "require" }] : [],
        style: {
          ...field.style,
          containerCss: isVisible ? "col-md-6 mb-2" : "col-md-6 mb-2 d-none"
        }
      };
    }
    return field;
  });

  updatedFormData.initialState = {
    ...updatedFormData.initialState,
    [fieldId]: isVisible ? updatedFormData.initialState[fieldId] : null
  };

  return updatedFormData;
};
